export const ROUTE_PATH = {
    MAIN: '/',
    AREA: '/area',
    PRIVACY: '/privacy',
    TERMS: '/terms'
}